import type { ListItemField } from '../../List/filters/ListItemFieldsFilter/ListItemFieldsFilter';
import type { TransferListBaseItem } from '../types';

export type ListItemFieldSave = {
  index?: number;
  isHidden: boolean;
};

export const readSavedFieldsConfig = <TItem extends TransferListBaseItem>(
  fields: ListItemField<TItem>[],
  localStorageKey: string
) => {
  try {
    const configString = localStorage.getItem(localStorageKey) || '';
    const config: Record<string, ListItemFieldSave | undefined> = JSON.parse(configString);

    const fieldsWithHiddenState = fields.map(field => {
      field.isHidden = !!config[field.id]?.isHidden;

      return field;
    });

    return fieldsWithHiddenState.sort((a, b) => {
      const indexA = config[a.id]?.index;
      const indexB = config[b.id]?.index;

      if (indexA === undefined) {
        return 1;
      }

      if (indexB === undefined) {
        return -1;
      }

      return indexA - indexB;
    });
  } catch (_err) {
    localStorage.removeItem(localStorageKey);
    return fields;
  }
};

export const updateSavedFieldsConfig = <TItem extends TransferListBaseItem>(
  fields: ListItemField<TItem>[],
  localStorageKey: string
) => {
  const configToSave = fields.reduce<Record<string, ListItemFieldSave>>((acc, { id, isHidden }, index) => {
    acc[id] = {
      index,
      isHidden: isHidden ?? false,
    };

    return acc;
  }, {});

  localStorage.setItem(localStorageKey, JSON.stringify(configToSave));
};
